import { useEffect } from 'react';
import { useMap } from '@vis.gl/react-google-maps';

type Props = { lat: number; lng: number; yOffsetPx?: number };

const MapPanner = ({ lat, lng, yOffsetPx = 0 }: Props) => {
  const map = useMap();
  useEffect(() => {
    if (!map) return;
    map.panTo({ lat, lng });
    if (yOffsetPx !== 0) map.panBy(0, yOffsetPx);
  }, [map, lat, lng, yOffsetPx]);
  return null;
};

export default MapPanner;
